import { Drawer, MultiSelect, SingleSelect } from '@loop/ui'
import { Box, Button, TextField, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import BackArrowBtnComp from 'src/components/OrderDrawer/components/BackArrowBtnComp'
import { ActionType } from '../SearchDialog'
import { StepInputType } from '../utils/actions'
import { useActionsManager } from '../utils/useActionsManager'

export default function ActionWizardDrawer({ open, handleClose, actionWizard }: { open: boolean; handleClose: () => void; actionWizard: ActionType }) {
  const { currentStep, actionState, handleStepNext, handleStepPrev, submitAction, isFinalStep, dynamicOptionsLoading } = useActionsManager(actionWizard?.id)

  const [inputValue, setInputValue] = useState('')
  const [selectedValues, setSelectedValues] = useState([])

  // Reset local state when step changes
  useEffect(() => {
    setInputValue('')
    setSelectedValues([])
  }, [currentStep])

  const handleNext = async () => {
    const stepData = {
      [currentStep?.step_key ?? currentStep?.step_id]:
        currentStep?.step_type === StepInputType.INPUT
          ? inputValue
          : currentStep?.step_type === StepInputType.SINGLE_SELECT
            ? selectedValues[0]
            : selectedValues
    }

    handleStepNext(stepData)
  }

  const handlePrevious = () => {
    handleStepPrev()
  }

  const renderInput = () => {
    if (dynamicOptionsLoading) {
      return <Typography>Loading options...</Typography>
    }

    switch (currentStep?.step_type) {
      case StepInputType.INPUT:
        return (
          <TextField
            fullWidth
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            label={currentStep.step_title}
          />
        )
      case StepInputType.SINGLE_SELECT:
        return (
          <SingleSelect
            options={actionState.dynamicOptions[currentStep.step_id] || []}
            value={selectedValues[0] || ''}
            onChange={(value) => setSelectedValues([value])}
            label={currentStep.step_title}
          />
        )
      case StepInputType.MULTI_SELECT:
        return (
          <MultiSelect
            options={actionState.dynamicOptions[currentStep.step_id] || []}
            value={selectedValues}
            onChange={(values) => setSelectedValues(values)}
            label={currentStep.step_title}
          />
        )
      default:
        return null
    }
  }

  return (
    <Drawer
      open={open}
      onClose={handleClose}>
      <Box sx={{ p: 3, minWidth: '300px', width: '50vw' }}>
        <Box
          display="flex"
          alignItems="center"
          gap={2}
          mb={3}>
          <BackArrowBtnComp onClick={handleClose} />
          <Typography
            fontSize="24px"
            fontWeight={600}>
            {actionWizard?.title}
          </Typography>
        </Box>

        <Typography
          fontSize="16px"
          fontWeight={600}>
          {currentStep?.step_title}
        </Typography>

        <Typography
          fontSize="14px"
          color="#0008">
          {currentStep?.step_description}
        </Typography>

        <Box sx={{ mt: 1 }}>{renderInput()}</Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
          <Button
            onClick={handlePrevious}
            disabled={actionState.currentStep === 0}>
            Previous
          </Button>

          <Button
            variant="contained"
            onClick={handleNext}
            disabled={
              (currentStep?.step_required &&
                ((currentStep?.step_type === StepInputType.INPUT && !inputValue) ||
                  (currentStep?.step_type !== StepInputType.INPUT && selectedValues.length === 0))) ||
              dynamicOptionsLoading
            }>
            {isFinalStep ? 'Submit' : 'Next'}
          </Button>
        </Box>
      </Box>
    </Drawer>
  )
}
